import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=b4a97e30&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=b4a97e30&prod&lang=scss"
import style1 from "./Create.vue?vue&type=style&index=1&id=b4a97e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a97e30",
  null
  
)

export default component.exports